@if (orderNumber) {
  <b (click)="downloadOpenOrder()" class="clickable withOpacity"><i class="material-icons">
    picture_as_pdf
  </i> {{orderNumber}}</b>
}
